// import config from '../../../config';
import React, { PureComponent } from 'react';
import path from 'path-browserify';
import { getIconForFile } from 'vscode-icons-js';

const STATIC_BUCKET = "https://static.bit.dev";

export class FileIcon extends PureComponent<{
	fileName: string;
	className: string;
}> {
	render() {
		const { fileName, className } = this.props;

		const iconName = getIconForFile(fileName);
		const url = `${STATIC_BUCKET}/file-icons/${iconName}`;

		const suffix = path.extname(fileName) || '?';

		return <img className={className} src={url} alt={suffix} />;
	}
}
